import { ɵɵdefineInjectable, ɵɵinject, Injectable, Directive, ElementRef, Host, Input, HostBinding, Component, ViewEncapsulation, ViewChild, TemplateRef, ContentChild, NgModule } from '@angular/core';
import { TourService, TourHotkeyListenerComponent } from 'ngx-tour-core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgbPopover, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import withinviewport from 'withinviewport';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = ["tourStep"];
function TourStepTemplateComponent_ng_template_0_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 4);
    ɵngcc0.ɵɵlistener("click", function TourStepTemplateComponent_ng_template_0_button_3_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.tourService.prev(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const step_r2 = ɵngcc0.ɵɵnextContext().step;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" \u00AB ", step_r2 == null ? null : step_r2.prevBtnTitle, " ");
} }
function TourStepTemplateComponent_ng_template_0_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 4);
    ɵngcc0.ɵɵlistener("click", function TourStepTemplateComponent_ng_template_0_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.tourService.next(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const step_r2 = ɵngcc0.ɵɵnextContext().step;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", step_r2 == null ? null : step_r2.nextBtnTitle, " \u00BB ");
} }
function TourStepTemplateComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p", 1);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵtemplate(3, TourStepTemplateComponent_ng_template_0_button_3_Template, 2, 1, "button", 3);
    ɵngcc0.ɵɵtemplate(4, TourStepTemplateComponent_ng_template_0_button_4_Template, 2, 1, "button", 3);
    ɵngcc0.ɵɵelementStart(5, "button", 4);
    ɵngcc0.ɵɵlistener("click", function TourStepTemplateComponent_ng_template_0_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.tourService.end(); });
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const step_r2 = ctx.step;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(step_r2 == null ? null : step_r2.content);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.tourService.hasPrev(step_r2));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.tourService.hasNext(step_r2));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", step_r2 == null ? null : step_r2.endBtnTitle, " ");
} }
class NgbTourService extends TourService {
}
NgbTourService.ɵfac = /*@__PURE__*/ function () { let ɵNgbTourService_BaseFactory; return function NgbTourService_Factory(t) { return (ɵNgbTourService_BaseFactory || (ɵNgbTourService_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(NgbTourService)))(t || NgbTourService); }; }();
NgbTourService.ɵprov = ɵɵdefineInjectable({ factory: function NgbTourService_Factory() { return new NgbTourService(ɵɵinject(Router)); }, token: NgbTourService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgbTourService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class TourStepTemplateService {
}
TourStepTemplateService.ɵfac = function TourStepTemplateService_Factory(t) { return new (t || TourStepTemplateService)(); };
TourStepTemplateService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: TourStepTemplateService, factory: TourStepTemplateService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TourStepTemplateService, [{
        type: Injectable
    }], null, null); })();

class TourAnchorNgBootstrapPopoverDirective extends NgbPopover {
}
TourAnchorNgBootstrapPopoverDirective.ɵfac = /*@__PURE__*/ function () { let ɵTourAnchorNgBootstrapPopoverDirective_BaseFactory; return function TourAnchorNgBootstrapPopoverDirective_Factory(t) { return (ɵTourAnchorNgBootstrapPopoverDirective_BaseFactory || (ɵTourAnchorNgBootstrapPopoverDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TourAnchorNgBootstrapPopoverDirective)))(t || TourAnchorNgBootstrapPopoverDirective); }; }();
TourAnchorNgBootstrapPopoverDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TourAnchorNgBootstrapPopoverDirective, selectors: [["", "tourAnchor", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TourAnchorNgBootstrapPopoverDirective, [{
        type: Directive,
        args: [{ selector: '[tourAnchor]' }]
    }], null, null); })();
class TourAnchorNgBootstrapDirective {
    constructor(tourService, tourStepTemplate, element, popoverDirective) {
        this.tourService = tourService;
        this.tourStepTemplate = tourStepTemplate;
        this.element = element;
        this.popoverDirective = popoverDirective;
        this.popoverDirective.autoClose = false;
        this.popoverDirective.triggers = '';
        this.popoverDirective.toggle = () => { };
    }
    ngOnInit() {
        this.tourService.register(this.tourAnchor, this);
    }
    ngOnDestroy() {
        this.tourService.unregister(this.tourAnchor);
    }
    showTourStep(step) {
        this.isActive = true;
        this.popoverDirective.ngbPopover = this.tourStepTemplate.template;
        this.popoverDirective.popoverTitle = step.title;
        this.popoverDirective.container = 'body';
        this.popoverDirective.placement = (step.placement || 'top')
            .replace('before', 'left').replace('after', 'right')
            .replace('below', 'bottom').replace('above', 'top');
        step.prevBtnTitle = step.prevBtnTitle || 'Prev';
        step.nextBtnTitle = step.nextBtnTitle || 'Next';
        step.endBtnTitle = step.endBtnTitle || 'End';
        this.popoverDirective.open({ step });
        if (!step.preventScrolling) {
            if (!withinviewport(this.element.nativeElement, { sides: 'bottom' })) {
                this.element.nativeElement.scrollIntoView(false);
            }
            else if (!withinviewport(this.element.nativeElement, { sides: 'left top right' })) {
                this.element.nativeElement.scrollIntoView(true);
            }
        }
    }
    hideTourStep() {
        this.isActive = false;
        this.popoverDirective.close();
    }
}
TourAnchorNgBootstrapDirective.ɵfac = function TourAnchorNgBootstrapDirective_Factory(t) { return new (t || TourAnchorNgBootstrapDirective)(ɵngcc0.ɵɵdirectiveInject(NgbTourService), ɵngcc0.ɵɵdirectiveInject(TourStepTemplateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(TourAnchorNgBootstrapPopoverDirective, 1)); };
TourAnchorNgBootstrapDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TourAnchorNgBootstrapDirective, selectors: [["", "tourAnchor", ""]], hostVars: 2, hostBindings: function TourAnchorNgBootstrapDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("touranchor--is-active", ctx.isActive);
    } }, inputs: { tourAnchor: "tourAnchor" } });
TourAnchorNgBootstrapDirective.ctorParameters = () => [
    { type: NgbTourService },
    { type: TourStepTemplateService },
    { type: ElementRef },
    { type: TourAnchorNgBootstrapPopoverDirective, decorators: [{ type: Host }] }
];
TourAnchorNgBootstrapDirective.propDecorators = {
    tourAnchor: [{ type: Input }],
    isActive: [{ type: HostBinding, args: ['class.touranchor--is-active',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TourAnchorNgBootstrapDirective, [{
        type: Directive,
        args: [{
                selector: '[tourAnchor]'
            }]
    }], function () { return [{ type: NgbTourService }, { type: TourStepTemplateService }, { type: ɵngcc0.ElementRef }, { type: TourAnchorNgBootstrapPopoverDirective, decorators: [{
                type: Host
            }] }]; }, { isActive: [{
            type: HostBinding,
            args: ['class.touranchor--is-active']
        }], tourAnchor: [{
            type: Input
        }] }); })();

class TourStepTemplateComponent extends TourHotkeyListenerComponent {
    constructor(tourStepTemplateService, tourService) {
        super(tourService);
        this.tourStepTemplateService = tourStepTemplateService;
        this.tourService = tourService;
    }
    ngAfterContentInit() {
        this.tourStepTemplateService.template =
            this.stepTemplate ||
                this.stepTemplateContent ||
                this.defaultTourStepTemplate;
    }
}
TourStepTemplateComponent.ɵfac = function TourStepTemplateComponent_Factory(t) { return new (t || TourStepTemplateComponent)(ɵngcc0.ɵɵdirectiveInject(TourStepTemplateService), ɵngcc0.ɵɵdirectiveInject(NgbTourService)); };
TourStepTemplateComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TourStepTemplateComponent, selectors: [["tour-step-template"]], contentQueries: function TourStepTemplateComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TemplateRef, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.stepTemplateContent = _t.first);
    } }, viewQuery: function TourStepTemplateComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7, TemplateRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.defaultTourStepTemplate = _t.first);
    } }, inputs: { stepTemplate: "stepTemplate" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 0, consts: [["tourStep", ""], [1, "tour-step-content"], [1, "tour-step-navigation"], ["class", "btn btn-sm btn-default", 3, "click", 4, "ngIf"], [1, "btn", "btn-sm", "btn-default", 3, "click"]], template: function TourStepTemplateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TourStepTemplateComponent_ng_template_0_Template, 7, 4, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
TourStepTemplateComponent.ctorParameters = () => [
    { type: TourStepTemplateService },
    { type: NgbTourService }
];
TourStepTemplateComponent.propDecorators = {
    defaultTourStepTemplate: [{ type: ViewChild, args: ['tourStep', { read: TemplateRef, static: true },] }],
    stepTemplate: [{ type: Input }],
    stepTemplateContent: [{ type: ContentChild, args: [TemplateRef,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TourStepTemplateComponent, [{
        type: Component,
        args: [{
                encapsulation: ViewEncapsulation.None,
                selector: 'tour-step-template',
                template: `
    <ng-template #tourStep let-step="step">
      <p class="tour-step-content">{{ step?.content }}</p>
      <div class="tour-step-navigation">
        <button
          *ngIf="tourService.hasPrev(step)"
          class="btn btn-sm btn-default"
          (click)="tourService.prev()"
        >
          « {{ step?.prevBtnTitle }}
        </button>
        <button
          *ngIf="tourService.hasNext(step)"
          class="btn btn-sm btn-default"
          (click)="tourService.next()"
        >
          {{ step?.nextBtnTitle }} »
        </button>
        <button class="btn btn-sm btn-default" (click)="tourService.end()">
          {{ step?.endBtnTitle }}
        </button>
      </div>
    </ng-template>
  `
            }]
    }], function () { return [{ type: TourStepTemplateService }, { type: NgbTourService }]; }, { defaultTourStepTemplate: [{
            type: ViewChild,
            args: ['tourStep', { read: TemplateRef, static: true }]
        }], stepTemplate: [{
            type: Input
        }], stepTemplateContent: [{
            type: ContentChild,
            args: [TemplateRef]
        }] }); })();

class TourNgBootstrapModule {
    static forRoot() {
        return {
            ngModule: TourNgBootstrapModule,
            providers: [
                TourStepTemplateService,
                TourService,
                NgbTourService
            ],
        };
    }
}
TourNgBootstrapModule.ɵfac = function TourNgBootstrapModule_Factory(t) { return new (t || TourNgBootstrapModule)(); };
TourNgBootstrapModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TourNgBootstrapModule });
TourNgBootstrapModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, NgbPopoverModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TourNgBootstrapModule, [{
        type: NgModule,
        args: [{
                declarations: [TourAnchorNgBootstrapDirective, TourAnchorNgBootstrapPopoverDirective, TourStepTemplateComponent],
                exports: [TourAnchorNgBootstrapDirective, TourAnchorNgBootstrapPopoverDirective, TourStepTemplateComponent],
                imports: [CommonModule, NgbPopoverModule]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TourNgBootstrapModule, { declarations: function () { return [TourAnchorNgBootstrapDirective, TourAnchorNgBootstrapPopoverDirective, TourStepTemplateComponent]; }, imports: function () { return [CommonModule, NgbPopoverModule]; }, exports: function () { return [TourAnchorNgBootstrapDirective, TourAnchorNgBootstrapPopoverDirective, TourStepTemplateComponent]; } }); })();

/*
 * Public API Surface of ngx-tour-ng-bootstrap
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TourAnchorNgBootstrapDirective, TourNgBootstrapModule, NgbTourService as TourService, TourStepTemplateComponent, NgbTourService as ɵa, TourAnchorNgBootstrapPopoverDirective as ɵb, TourStepTemplateService as ɵc };

